import { NextSearchParams } from '@/types/general'

export const searchParamsToObject = (searchParams: URLSearchParams) => {
    const paramsObj: NextSearchParams = {}

    searchParams.forEach((value, key) => {
        if (key in paramsObj) {
            paramsObj[key] = Array.isArray(paramsObj[key]) ? [...paramsObj[key], value] : [paramsObj[key] || '', value]
        } else {
            paramsObj[key] = value
        }
    })

    return paramsObj
}
